export default __webpack_public_path__ + "static/media/frost-blade.bf7ba17a.gif";